const html = require('choo/html');
const onload = require('on-load');
const { unselectedAnswerStyle, stickToBottomZ } = require('../lib/styles');

const TITLE = 'Can You Spot the Terrorist';

module.exports = view;

function view(state, emit) {
  if (state.title !== TITLE) emit(state.events.DOMTITLECHANGE, TITLE);

  let header = '';
  let logo = '';

  function loadHeader() {
    header = new TI.nav.Header();
    logo = new TI.branding.Logo({
      color: '#001B44',
      link: {
        target: '_blank',
        url: 'https://theintercept.com/'
      }
    });

    let el = document.querySelector('#app-header');

    if (el.querySelector('.ti-nav-header') === null) {
      state.query.embed == 'true' ? '' : el.appendChild(header.element);
    }
  }

  const el = html`
    <div>
      <div id="app" class="mw8-ns center lh-copy ti-sans navy">
        <div id="app-header" class="">
          <div id="app-header-el"></div>
        </div>
        <main class="pa3 cf center">
          <div class="title ba bw3">
            <h1
              class="f-headline-l f0-m f2 mb0 mt6-ns mt4-m mt4 lh-solid ttu ti-sans-blk"
            >
              Can You Spot the Terrorist?
            </h1>
            <h2 class="f3-ns f3 mt3 mb6-ns mb4-m mb4 lh-solid ti-sans-semib">
              The Justice Department has prosecuted hundreds of violent domestic extremists since 9/11. Guess which ones the government treated as terrorists.
            </h2>
          </div>
        </main>
        <section class="${stickToBottomZ}">
          <div
            class="${unselectedAnswerStyle}"
            onclick="${() => {
              emit('quiz:start');
            }}"
          >
            Take the quiz!
          </div>
        </section>
      </div>
    </div>
  `;
  onload(el, loadHeader);
  return el;
}
